<script lang="ts" context="module">
  import Layout from "@/Layouts/Alignment.svelte"
  export const layout = Layout
</script>

<script lang="ts">
  import { setContext } from "svelte"
  import PreAlignmentResults from "../AlignmentTest/PreAlignmentResults.svelte"
  import PostAlignmentResults from "../AlignmentTest/PostAlignmentResults.svelte"

  export let plan: any
  export let alignment_test: any
  export let result_type: string

  setContext("plan", plan)
</script>

<div class="mt-4" id="header">
  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    {#if result_type === "post"}
      <PostAlignmentResults {alignment_test} />
    {:else if result_type === "pre"}
      <PreAlignmentResults {alignment_test} />
    {/if}
  </div>
</div>
